import { render, staticRenderFns } from "./AdminTransaction.vue?vue&type=template&id=396dc3e3&scoped=true"
import script from "./AdminTransaction.vue?vue&type=script&lang=js"
export * from "./AdminTransaction.vue?vue&type=script&lang=js"
import style0 from "./AdminTransaction.vue?vue&type=style&index=0&id=396dc3e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396dc3e3",
  null
  
)

export default component.exports